import { MantineProvider } from "@mantine/styles";
import ReactDOM from "react-dom";
import App from "./App";
import mantineTheme from "./config/mantine.config";
import "./index.css";

ReactDOM.render(
  <MantineProvider theme={mantineTheme}>
    <App />
  </MantineProvider>,
  document.getElementById("root")
);
